// Only the deltas from .lk-product-card — the shell, body, and bottom row are
// shared with ProductCard.styles.ts.
export const COACH_CARD_CSS = /* css */ `
  /* Product shots are transparent PNGs that need letterboxing; a coach photo is
     a portrait that should fill the frame. "top center" keeps faces in view
     when the crop is tall. */
  .lk-coach-card-image {
    background-size: cover;
    background-position: top center;
    background-color: var(--wg-bg-secondary, #EFF4F3);
  }
  .lk-coach-card-meta {
    font-size: 11px;
    font-weight: 500;
    color: var(--wg-card-fg-muted, #586577);
    margin: 2px 0 6px;
  }
  /* "From $65/lesson" and "Book a lesson" share a 240px card. */
  .lk-coach-card .lk-product-card-bottom {
    gap: 8px;
  }
  .lk-coach-card .lk-product-card-price,
  .lk-coach-card .lk-product-card-cta {
    white-space: nowrap;
  }
  .lk-coach-card-per {
    font-size: 11px;
    font-weight: 500;
    color: var(--wg-card-fg-muted, #586577);
    margin-left: 1px;
  }
`;
